import ajax from '../utils/ajax'

// 搜索基调
export function searchEm(em) {
    return ajax({
        url: '/v3/em/music',
        method: 'POST',
        data: em
    })
}

// 获取插件过滤信息
export function getVstPluginFilterInfo() {
    return ajax({
        url: '/v3/em/filter',
        method: 'POST'
    })
}

// 获取插件配置
export function getVstPluginConfig() {
    return ajax({
        url: '/v3/em/cnf',
        method: 'POST'
    })
}

export function getValidCode(params) {
    return ajax({
        url: '/v3/sessions',
        method: 'POST',
        data: params
    })
}

export function login(params) {
    return ajax({
        url: '/v3/sessions',
        method: 'POST',
        data: params
    })
}


export function getKeywords() {
    return ajax({
        url: '/v3/em/keywords',
        method: 'POST'
    })
}

export function getVipCheck() {
    return ajax({
        url: '/v3/em/vipcheck',
        method: 'POST'
    })
}

export function getPayaddr() {
    return ajax({
        url: '/v3/em/payaddr',
        method: 'POST'
    })
}

export function getProductBaseInfo(product) {
    return ajax({
        url: '/v3/product/base',
        method: 'POST',
        data: product
    })
}

export function userLoginValid() {
    return ajax({
        url: '/v3/sessions/valider',
        method: 'POST'
    })
}

export function getPromotion() {
    return ajax({
        url: '/v3/pay/promocomms',
        method: 'POST'
    })
}

// 微信登录
export function weixinLogin() {
    return ajax({
        url: '/v3/weixin',
        method: 'POST'
    })
}

// 微信登录结果验证
export function weixinLoginQuery(loginState) {
    return ajax({
        url: '/v3/weixinquery',
        method: 'POST',
        data: loginState
    })
}

// 手机号绑微信 获取验证码
export function getBindWeixinPhoneCode() {
    return ajax({
        url: '/v3/userbind/weixinvalidcode',
        method: 'POST'
    })
}

// 手机号绑微信 获取绑定信息 二维码
export function userInfoBindWeixin(bindInfo) {
    return ajax({
        url: '/v3/userbind/weixin',
        method: 'POST',
        data: bindInfo
    })
}

// 手机号绑微信 验证绑定结果
export function userInfoBindQuery(bindInfo) {
    return ajax({
        url: '/v3/userbind/query',
        method: 'POST',
        data: bindInfo
    })
}

/**
 * 获取WAF验证码
 */
export function getWafCaptcha() {
    return ajax({
        url: '/v3/gatewaywaf/captcha',
        method: 'GET'
    })
}

/**
 * 验证WAF验证码
 */
export function verifyWafCaptcha(captchaData) {
    return ajax({
        url: '/v3/gatewaywaf/captcha/verify',
        method: 'POST',
        data: captchaData
    })
}

/**
 * 获取受限用户申请信息
 */
export function restrictedApply() {
    return ajax({
        url: '/v3/users/restricted/apply',
        method: 'POST'
    })
}
/**
 * 查询受限用户状态
 */
export function restrictedCheck() {
    return ajax({
        url: '/v3/users/restricted/check',
        method: 'POST'
    })
}
/**
 * 主动检查用户是否受限
 */
export function restrictedJudge() {
    return ajax({
        url: '/v3/users/restricted/judge',
        method: 'POST'
    })
}



// 基调回传（AI 分析 3 票入库 / 手动立即入库）
export function uploadKeynote(params) {
    return ajax({
        url: '/v3/em/knupload',
        method: 'POST',
        data: params
    })
}

// 电音精调默认值（后台配置）：恢复默认时用它写回本机设置
export function getUiExtConf() {
    return ajax({
        url: '/v3/em/uiextconf',
        method: 'POST',
        data: {}
    })
}

// 会员套餐列表（后台「套餐商品」配的，只返回上架的）
export function getPayGoods() {
    return ajax({
        url: '/v3/pay/goods',
        method: 'POST',
        data: {}
    })
}

// 下单（支付还没对接，后端返回占位订单）
export function createPayOrder(goodsId) {
    return ajax({
        url: '/v3/pay/create',
        method: 'POST',
        data: { goodsId }
    })
}
